import { io } from 'socket.io-client';
import { ApiEventNames } from '../shared/api-contract';
import type { Order } from '../shared/types';
import { API_BASE_URL } from '../config/runtime';

let socket: ReturnType<typeof io> | null = null;

/* eslint-disable no-unused-vars */
export interface OrdersRealtimeStore {
  orders: Order[];
  pushOrder: (_order: Order) => void;
  replaceOrder: (_order: Order) => void;
}
/* eslint-enable no-unused-vars */

export const connectRealtime = (store: OrdersRealtimeStore) => {
  if (socket) {
    return socket;
  }

  socket = io(API_BASE_URL, {
    transports: ['websocket', 'polling'],
  });

  socket.on('connect', () => {
    console.log('Realtime connected', socket?.id);
  });

  socket.on(ApiEventNames.orderCreated, (payload: { order: Order }) => {
    if (!store.orders.find((order) => order.id === payload.order.id)) {
      store.pushOrder(payload.order);
    }
  });

  socket.on(ApiEventNames.orderUpdated, (payload: { order: Order }) => {
    store.replaceOrder(payload.order);
  });

  socket.on('disconnect', () => {
    console.log('Realtime disconnected');
  });

  return socket;
};
